import React, { useRef, useEffect, useState } from 'react';
import { Box, Pagination } from '@mui/material';
import CurrentSpecialOfferCard from '@components/CurrentSpecialOffers/components/CurrentSpecialOfferCard';
import { useGetSpecialOffers } from '@hooks/useSpecialOffers';

const SpecialOffersFeed = () => {
  const ref = useRef<HTMLDivElement>(null);

  const { data: specialOffers } = useGetSpecialOffers();

  // State to decide if the component should be displayed
  const [shouldRender, setShouldRender] = useState<boolean>(false);
  // State to manage the current page index
  const [pageIndex, setPageIndex] = useState<number>(0);

  // when special offers are loaded set the index to random
  useEffect(() => {
    if (specialOffers && specialOffers?.length > 0) {
      setPageIndex(Math.floor(Math.random() * specialOffers.length));
    }
  }, [specialOffers]);

  useEffect(() => {
    // Decide to render the component or not based on a random number
    const render = Math.random() < 0.3; // 30% chance to render
    setShouldRender(render);
  }, []); // Empty dependency array to run only once on mount

  if (!shouldRender || !specialOffers || specialOffers?.length === 0) {
    return null; // Do not render anything if shouldRender is false
  }

  const handlePageChange = (
    _event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPageIndex(value - 1); // Pagination is 1-based
  };

  return (
    <Box
      sx={{
        backgroundColor: 'rgba(128, 128, 128, 0.16)',
        display: {
          xs: 'block',
          lg: 'none'
        },
        width: '100%',
        marginLeft: '-17px',
        marginRight: '-16px',
        padding: '0 16px 16px 16px'
      }}
      ref={ref}
    >
      <Box padding="8px 0">
        <CurrentSpecialOfferCard
          small
          so={specialOffers[pageIndex]}
          elevation={4}
        />
      </Box>
      {specialOffers.length > 1 ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Pagination
            count={specialOffers.length}
            page={pageIndex + 1}
            onChange={handlePageChange}
            color="primary"
            sx={{
              marginBottom: '16px'
            }}
          />
        </Box>
      ) : null}
    </Box>
  );
};

export default SpecialOffersFeed;
